import React, { useEffect, useState } from 'react';
import api from '../services/ApiService';
import liveSocket from '../services/LiveSocketService';

export default function Wallboard() {
  const [data, setData] = useState<any>(null);

  const loadWallboard = async () => {
    try {
      const res = await api.getWallboard();
      setData(res);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
  loadWallboard();

  liveSocket.connect();

  const unsubscribe = liveSocket.subscribe((event: any) => {
    if (
      [
        'agent_state_changed',
        'queue_login',
        'queue_logout'
      ].includes(event.type)
    ) {
      loadWallboard();
    }
  });

  return () => {
    unsubscribe();
  };
}, []);

  if (!data) {
    return (
      <div className="content-card">
        Loading wallboard...
      </div>
    );
  }

  const s = data.stats || {};

  return (
    <>
      <div className="admin-page-title">
        Live Wallboard
      </div>

      <div className="admin-page-subtitle">
        Tenant-safe realtime operational monitoring.
      </div>

      <div className="dashboard-grid">
        <StatCard title="Agents" value={s.total_agents || 0} />
        <StatCard title="Available" value={s.available_agents || 0} />
        <StatCard title="Paused" value={s.paused_agents || 0} />
        <StatCard title="Talking" value={s.talking_agents || 0} />
        <StatCard title="Offline" value={s.offline_agents || 0} />
        <StatCard title="Queues" value={s.active_queues || 0} />
        <StatCard title="Logged In" value={s.logged_in_queue_sessions || 0} />
      </div>

      <div className="content-card">
        <h3>Live Agents</h3>

        <table className="admin-table">
          <thead>
            <tr>
              <th>User</th>
              <th>State</th>
              <th>Queue</th>
              <th>Updated</th>
            </tr>
          </thead>

          <tbody>
            {data.live_agents.map((a: any, idx: number) => (
              <tr key={idx}>
                <td>{a.username}</td>
                <td>
                  <span className={`admin-pill ${pill(a.state)}`}>
                    {a.state}
                  </span>
                </td>
                <td>{a.queue_name || '-'}</td>
                <td>{a.updated_at || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="content-card">
        <h3>Recent Agent Events</h3>

        <table className="admin-table">
          <thead>
            <tr>
              <th>Agent</th>
              <th>Previous</th>
              <th>Current</th>
              <th>Reason</th>
              <th>Queue</th>
              <th>Time</th>
            </tr>
          </thead>

          <tbody>
            {data.recent_events.map((e: any) => (
              <tr key={e.id}>
                <td>{e.username}</td>
                <td>{e.previous_state}</td>
                <td>
                  <span className={`admin-pill ${pill(e.new_state)}`}>
                    {e.new_state}
                  </span>
                </td>
                <td>{e.pause_reason || '-'}</td>
                <td>{e.queue_name || '-'}</td>
                <td>{e.created_at}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

function StatCard({ title, value }: any) {
  return (
    <div className="stat-card">
      <div className="stat-title">{title}</div>
      <div className="stat-value">{value}</div>
    </div>
  );
}

function pill(state: string) {
  if (state === 'available') return 'green';
  if (state === 'talking') return 'green';
  if (state === 'paused') return 'red';
  if (state === 'offline') return 'red';
  return '';
}